<template>
	<v-container fluid fill-height>
		<v-row justify="center">
			<v-col cols="12" xs="12" sm="6">
				<v-card class="error--text" outlined>
					<v-card-title class="px-2 py-0 mt-2">
						<v-row no-gutters align="center" class="post_title">
							<v-col cols="12" xs="12" align="center">
								<span>Errore</span>
								<v-icon x-small class="pl-2">fas fa-warning</v-icon>
							</v-col>
						</v-row>
					</v-card-title>
					<v-card-text>
						<v-row align="center" class="post_content">
							<v-col cols="12" xs="12" align="center">
								<span>{{ serverdownmessage }}</span>
							</v-col>
						</v-row>
					</v-card-text>
					<v-card-actions>
						<v-row dense justify="center">
							<v-col cols="6" xs="6">
								<action-button outlined small block text="Riprova" color="error" @click="$router.go()"></action-button>
							</v-col>
						</v-row>
					</v-card-actions>
				</v-card>
			</v-col>
		</v-row>
	</v-container>
</template>

<script>
export default {
	data: () => ({}),
	props: {},
	computed: {
		serverdownmessage() {
			return this.$store.getters.serverdownmessage;
		},
	},
};
</script>
